import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/ServerInformation'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class ServerInformationStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "ServerInformationStore",
			variables: false,
		})
	}
}

export async function load_ServerInformation(params) {
  await initClient()

	const store = new ServerInformationStore()

	await store.fetch(params)

	return {
		ServerInformation: store,
	}
}
